import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () =>
        import(
            /* webpackChunkName: "LazyRewardDashboardChunks" */ './RewardsWelcomeBannerAndPointsConnect'
        ),
    {
        fallback: <div>Loading...</div>,
    }
);
